import React, { useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';

const defaultAvatar = 'https://x0.ifengimg.com/ucms/2022_47/D72D94EFD9ED23EB0CFDEAF18B373135BF250198_size2_w52_h52.png';

const Avatar = ({ content }) => {
    const { url } = content;
    const [avatarUrl, setAvatarUrl] = useState(url ? formatImage(url, 56, 56) : defaultAvatar);

    return (
        <img
            className={styles.pic}
            src={avatarUrl}
            alt=""
            onError={() => {
                setAvatarUrl(defaultAvatar);
            }}
        />
    );
};

Avatar.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Avatar);
